import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import { useAuth } from './auth';
import { PageBack, PageHeader } from './components';
import { ThemeToggle } from './theme';
import { Layout } from './Layout';
import { DataTerms } from './pages/DataTerms';
import { FirmControl } from './pages/FirmControl';
import { FirmControls } from './pages/FirmControls';
import { FirmOverview } from './pages/FirmOverview';
import { FirmRisks } from './pages/FirmRisks';
import { GuidanceControl, GuidanceControls, GuidanceResources } from './pages/Guidance';
import { Home } from './pages/Home';
import { Leadership } from './pages/Leadership';
import { National } from './pages/National';
import { FormerFirmGate } from './pages/FormerFirm';
import { FirmPoliciesPage, PolicyTemplates } from './pages/Policies';
import { ReviewRoute, ReviewSubmission } from './pages/Review';
import { SelfAssessmentRedirect } from './pages/SelfAssessment';

function NotFound() {
  return (
    <>
      <PageBack to="/">Back to Home</PageBack>
      <PageHeader title="Page not found" lede="The page you asked for does not exist, or is outside your access." />
    </>
  );
}

const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      { path: '/', element: <Home /> },
      { path: '/guidance', element: <GuidanceControls /> },
      { path: '/guidance/controls/:controlId', element: <GuidanceControl /> },
      // Maturity is explained on the controls page (Andres, 2026-09-22); old links still land there.
      { path: '/guidance/maturity', element: <Navigate to="/guidance#maturity" replace /> },
      { path: '/guidance/resources', element: <GuidanceResources /> },
      { path: '/guidance/policies', element: <PolicyTemplates /> },
      { path: '/firm/:firmCode', element: <FormerFirmGate><FirmOverview /></FormerFirmGate> },
      { path: '/firm/:firmCode/controls', element: <FormerFirmGate><FirmControls /></FormerFirmGate> },
      { path: '/firm/:firmCode/controls/:controlId', element: <FormerFirmGate><FirmControl /></FormerFirmGate> },
      { path: '/firm/:firmCode/risks', element: <FormerFirmGate><FirmRisks /></FormerFirmGate> },
      { path: '/firm/:firmCode/self-assessment', element: <FormerFirmGate><SelfAssessmentRedirect /></FormerFirmGate> },
      { path: '/firm/:firmCode/policies', element: <FormerFirmGate><FirmPoliciesPage /></FormerFirmGate> },
      { path: '/leadership', element: <Leadership /> },
      { path: '/national', element: <National /> },
      // 5D B: for National IT the review queue is the National view's Reviews tab; this address lands there.
      { path: '/review', element: <ReviewRoute /> },
      { path: '/review/:submissionId', element: <ReviewSubmission /> },
      { path: '/help/data-terms', element: <DataTerms /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]);

function SignIn() {
  const { signIn } = useAuth();
  return (
    <>
      <header className="top">
        <div className="shell top-bar">
          <div className="brand">
            <img src="/logo-white.svg" alt="Baker Tilly" />
            <span className="title">Cyber Resilience Program</span>
          </div>
          <div className="top-actions">
            <ThemeToggle />
          </div>
        </div>
      </header>
      <main className="shell">
        <PageHeader eyebrow="Network-wide Cyber Resilience &amp; Risk Reduction Program" title="Cyber Resilience Program" lede="Sign in with your Baker Tilly account to see guidance, your firm's progress and National resources." />
        <button className="pill" onClick={signIn}>
          Sign in
        </button>
      </main>
    </>
  );
}

export function App() {
  const { signedIn } = useAuth();
  return signedIn ? <RouterProvider router={router} /> : <SignIn />;
}
